import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetAddressesByZipInput } from './GetAddressesByZipInput';
import { GetAddressesByZipOutput } from './GetAddressesByZipOutput';

export class GetAddressesByZipService extends HttpServiceBase {

    handle = (input: GetAddressesByZipInput): Promise<Result<GetAddressesByZipOutput>|null> => {
        const promise = this.http.get<Result<GetAddressesByZipOutput>>(`${this.baseUrlZerezesApi}/address/zipCode/${input.zip}`);
        return promise;
    }
}